import React from "react";

import { Week } from "@/client/api";
import { currentMonday, formatWeekRange } from "@/client/pages/plan/types";

export function WeekPicker({
  weeks,
  currentStartDate,
  onSelect,
  onClose,
}: {
  weeks: Week[];
  currentStartDate: string;
  onSelect: (startDate: string) => void;
  onClose: () => void;
}) {
  const thisMonday = currentMonday();
  return (
    <div className="absolute top-full left-0 mt-1 z-50 bg-term-surface border border-term-border rounded-xl shadow-xl py-1 min-w-56 max-h-64 overflow-y-auto max-w-[calc(100vw-2rem)]">
      {weeks.map((w) => (
        <button
          key={w.id}
          onClick={() => {
            onSelect(w.start_date);
            onClose();
          }}
          className={`w-full text-left px-4 py-2 text-sm cursor-pointer transition-colors flex items-center gap-3 ${
            w.start_date === currentStartDate
              ? "bg-term-accent/10 text-term-accent font-medium"
              : "text-term-text-dim hover:bg-term-raised hover:text-term-text"
          }`}
        >
          <span className="flex-1">{formatWeekRange(w.start_date)}</span>
          {w.start_date === thisMonday && (
            <span className="text-micro text-term-user font-medium">actual</span>
          )}
        </button>
      ))}
      {weeks.length === 0 && (
        <p className="text-sm text-term-text-muted px-4 py-3">Sin semanas creadas</p>
      )}
    </div>
  );
}
